import saveQuoteMetadata from 'core/services/saveQuoteMetadata'
import store from 'utils/store/withMiddleware'
import getUrlProfile from 'utils/pivot/member/getURLProfile'
import { propAccessor } from '@hc-frontend/utils'
import getURLParams from 'utils/DOM/getURLParams'
import { IS_AGENT } from 'core/constants/environment'

const pickExisting = data =>
  Object.entries(data).reduce((acc, [key, value]) => {
    if (value) {
      acc[key] = value
    }
    return acc
  }, {})

const contactParameters = state =>
  pickExisting({
    firstName: propAccessor(state, 'hcStorage.contact.first_name'),
    email: propAccessor(state, 'hcStorage.contact.email_address')
  })

const primaryMemberParameters = state => {
  const primaryMember =
    state.hcStorage.members &&
    state.hcStorage.members.length &&
    state.hcStorage.members.find(m => m.id === 'primary')

  if (!primaryMember) {
    return {}
  }

  return pickExisting({
    firstName: primaryMember.firstName,
    lastName: primaryMember.lastName,
    email: primaryMember.email
  })
}
const planParameters = state => {
  if (state.planId) {
    const plan = state.plans[state.planId]
    const parameters = {
      planName: plan.planName,
      isMulticarrier: plan.multiCarrierPlan
    }
    const policies = propAccessor(state, 'filters.policies')
    const period = plan.multiCarrierPlan ? '120' : propAccessor(state, 'filters.period')
    if (period) {
      parameters.planDuration = `${policies ? `${policies}X` : ''}${period}`
    }

    return parameters
  }
}

const urlQueryParameters = () => {
  const urlParams = getURLParams()

  return pickExisting({
    firstName: urlParams['fname'],
    lastName: urlParams['lname'],
    email: urlParams['email'],
    agentId: urlParams['agent_id'],
    quoteKey: urlParams['quoteKey']
  })
}

const createLink = (state, placementUrl, agentId) =>
  `https://${window.location.hostname}${placementUrl}?${getUrlProfile({
    stateRef: state,
    addPlanId: true,
    agentId,
    addProfile: true,
    addQuoteKey: true
  })}`

const getState = storeRef => {
  if (storeRef && storeRef.hcStorage && storeRef.quoteKey) {
    return storeRef
  } else if (storeRef && storeRef.getState) {
    return storeRef.getState()
  } else {
    return store.getState()
  }
}

const forMultiCarrier = state => {
  const urlParams = getURLParams()
  const months = urlParams['months'] ? parseInt(urlParams['months']) : 0
  return state.eligibilityBool && state.eligibilityMonths > 4 && months > 4
}

const createAndSaveQuoteMetadata = placementUrl => storeRef => {
  if (!IS_AGENT) {
    return storeRef
  }

  const state = getState(storeRef)
  const agentId = propAccessor(state, 'agentInfo.agentId') as string

  const metaData = {
    quoteKey: state.quoteKey,
    agentId,
    isMulticarrier: forMultiCarrier(state),
    link: createLink(state, placementUrl, agentId),
    // The order to spread the objects is important to define the priority of the data
    ...urlQueryParameters(),
    ...contactParameters(state),
    ...primaryMemberParameters(state),
    ...planParameters(state)
  }

  saveQuoteMetadata(metaData).catch(error =>
    console.error('[X] Error saving quote metadata', error)
  )

  return storeRef
}

export default createAndSaveQuoteMetadata
